import { buttonLightStyle } from "../styles";

import { saveThemeCookie } from "../lib/manageCookies";

import { useNavigate } from "react-router-dom";

interface HeaderProps extends MobileMode, OrientationMode, ThemeProps {
  setLockerClosed: SetBoolean;
  isQuizCompleted: boolean;
  setAuth: SetBoolean;
}

export default function Header({
  isMobile,
  isVertical,
  isDark,
  setDark,
  setLockerClosed,
  isQuizCompleted,
  setAuth,
}: HeaderProps) {
  const navigate = useNavigate();

  const desktopHeaderStyle = `sm:px-20 lg:px-40 xl:justify-between xl:py-2 ${
    isVertical ? "h-[3vh]" : "h-[6vh]"
  } `;

  const mobileHeaderStyle = "px-[5vw] h-[10vh]";

  const isHorizontalMobile = isMobile && !isVertical;

  const handleLogout = async () => {
    const response = await fetch("https://yda-wedding.fun/api/logout", {
      method: "POST",
      credentials: "include",
    });

    if (response.ok) {
      setAuth(false);
      navigate("/login");
    }
  };

  return (
    <header
      className={`${
        isHorizontalMobile ? "hidden" : ""
      } flex w-full justify-between items-center py-8 ${
        isDark ? "bg-gray-600" : "bg-light-header"
      } 
    ${isMobile ? mobileHeaderStyle : desktopHeaderStyle}`}
    >
      <button onClick={() => setLockerClosed(false)}>
        <img
          src={`/header/logo-${isDark ? "dark" : "light"}.png`}
          alt="logo"
          width={"40px"}
        />
      </button>
      <button
        onClick={() => {
          saveThemeCookie(!isDark);
          setDark(!isDark);
        }}
        className={isMobile ? "" : "ml-40"}
      >
        <img
          src={isDark ? "/header/theme-dark.png" : "/header/theme-light.png"}
          alt="theme"
          width={"40px"}
        />
      </button>
      <div className={`flex ${isMobile ? "gap-8" : "gap-12"}`}>
        <div className={isMobile ? "w-16" : "w-20"}>
          <button
            className={
              isQuizCompleted
                ? `${buttonLightStyle} ${
                    isDark ? "bg-gray-800" : "bg-tea-rose"
                  }`
                : "hidden"
            }
            onClick={() => {
              window.open("/photos", "_blank");
            }}
          >
            Фото
          </button>
        </div>
        <button
          className={`${buttonLightStyle} ${
            isDark ? "bg-gray-800" : "bg-tea-rose"
          }`}
          onClick={handleLogout}
        >
          Выйти
        </button>
      </div>
    </header>
  );
}
